import React from 'react';
import { Alert } from 'reactstrap';

import useOnline from 'utils/hooks/useOnline';

export default function OnlineCheck() {
  const isOnline = useOnline();

  if (isOnline) return null;

  return (
    <Alert color="danger" id="fixedOnlineAlert" className="my-0 fadeInUp">
      No internet connection. Try again when you are online.
    </Alert>
  );
}
